import { Dialog, Transition } from '@headlessui/react';
import { Fragment } from 'react';
import { useReactToPrint } from 'react-to-print';
import { IconPrinter, IconX, IconCheck } from '@tabler/icons-react';

export default function CetakStroke({ closeModal, isOpen, strukComponent }) {
  const handlePrint = useReactToPrint({
    content: () => strukComponent?.current,
    // onAfterPrint sengaja tidak menutup modal otomatis agar opsi cetak atau tutup tetap normal
  });

  return (
    <Transition appear show={isOpen} as={Fragment}>
      <Dialog as="div" className="relative z-50" onClose={closeModal || (() => {})}>
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-slate-900/60 dark:bg-slate-950/80 backdrop-blur-sm" />
        </Transition.Child>

        <div className="fixed inset-0 overflow-y-auto">
          <div className="flex min-h-full items-center justify-center p-4 text-center">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 scale-95"
              enterTo="opacity-100 scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 scale-100"
              leaveTo="opacity-0 scale-95"
            >
              <Dialog.Panel className="relative w-full max-w-md transform overflow-hidden rounded-2xl bg-white dark:bg-[#131b2e] border border-slate-200 dark:border-slate-800 p-6 text-center align-middle shadow-2xl transition-all">
                {/* Tombol X Tutup di Pojok Kanan Atas */}
                <button
                  type="button"
                  onClick={() => closeModal?.()}
                  className="absolute top-4 right-4 p-1.5 rounded-lg text-slate-400 hover:text-slate-600 dark:hover:text-slate-200 hover:bg-slate-100 dark:hover:bg-slate-800 transition cursor-pointer"
                  title="Tutup Modal"
                >
                  <IconX size={18} />
                </button>

                {/* Indikator Sukses */}
                <div className="w-16 h-16 rounded-2xl bg-emerald-100 dark:bg-emerald-950/60 text-emerald-600 dark:text-emerald-400 mx-auto flex items-center justify-center mb-4">
                  <IconCheck size={36} stroke={2.5} />
                </div>

                <Dialog.Title as="h2" className="text-xl font-bold text-slate-800 dark:text-slate-100 mb-2">
                  Transaksi Berhasil
                </Dialog.Title>

                <p className="text-sm text-slate-500 dark:text-slate-400 mb-6">
                  Transaksi penjualan telah berhasil disimpan. Silakan cetak struk atau tutup untuk melanjutkan transaksi berikutnya.
                </p>

                {/* Opsi Normal: Tutup & Cetak Struk */}
                <div className="flex items-center justify-center gap-3">
                  <button
                    type="button"
                    onClick={() => closeModal?.()}
                    className="flex-1 py-2.5 px-4 rounded-xl font-semibold text-sm text-slate-700 dark:text-slate-200 bg-slate-100 hover:bg-slate-200 dark:bg-slate-800 dark:hover:bg-slate-700 active:scale-95 border border-slate-200 dark:border-slate-700 transition cursor-pointer flex items-center justify-center gap-1.5"
                  >
                    <IconX size={16} />
                    <span>Tutup</span>
                  </button>

                  <button
                    type="button"
                    autoFocus
                    onClick={() => handlePrint()}
                    className="flex-1 py-2.5 px-4 rounded-xl font-bold text-sm text-white bg-amber-500 hover:bg-amber-600 active:scale-95 shadow-md shadow-amber-500/20 transition cursor-pointer flex items-center justify-center gap-1.5"
                  >
                    <IconPrinter size={18} />
                    <span>Cetak Struk</span>
                  </button>
                </div>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition>
  );
}
